(function () {
  // Collection sorting
  var sort = document.getElementById('sort-by');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  // Product gallery thumbnails
  var main = document.getElementById('pdp-main-img');
  document.querySelectorAll('.pdp__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) { main.removeAttribute('srcset'); main.src = btn.dataset.src; }
      document.querySelectorAll('.pdp__thumb').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
  // Variant price update
  var vs = document.getElementById('variant-select');
  var price = document.getElementById('pdp-price');
  if (vs && price) {
    vs.addEventListener('change', function () {
      var o = vs.options[vs.selectedIndex];
      if (o && o.dataset.price) price.textContent = o.dataset.price;
    });
  }
})();
